import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './FactOrFictionButtons.module.scss';
import classNames from 'classnames';
import FactButton from './FactButton';
import {playAudio} from './mediaBundle';

export default class FactOrFictionButtons extends Component {
    static propTypes = {
        scenario: PropTypes.object.isRequired,
        userChoice: PropTypes.object.isRequired,
        disabled: PropTypes.bool,
        onUpdateUserChoice: PropTypes.func.isRequired,
    };

    render() {
        const {userChoice, disabled} = this.props;

        const containerStyle = {
            opacity: disabled ? 0 : 1,
        };

        const userWrongFactSelected =
            userChoice.factSelected && this.isWrongFact(userChoice.fact);
        const wrongFact = userWrongFactSelected && userChoice.fact;
        const wrongFiction = userWrongFactSelected && !userChoice.fact;

        return (
            <div
                key={userChoice.factSelection}
                style={containerStyle}
                className={styles.factFictionButtons}
            >
                <FactButton
                    label='Fact'
                    inError={wrongFact}
                    onClick={this.selectFact({fact: true})}
                />
                <div className={styles.or}>or</div>
                <FactButton
                    label='Fiction'
                    inError={wrongFiction}
                    onClick={this.selectFact({fact: false})}
                />
            </div>
        );
    }

    isWrongFact(fact) {
        const {scenario} = this.props;
        return fact !== scenario.fact;
    }

    selectFact = ({fact}) => () => {
        const {userChoice, disabled} = this.props;

        if (disabled) return;

        if (this.isWrongFact(fact)) {
            playAudio('wrongFact');
        } else {
            playAudio('rightFact');
        }

        this.props.onUpdateUserChoice({
            factSelected: true,
            fact,
            factSelection: (userChoice.factSelection || 0) + 1,
        });
    };
}
